import React from "react";
import {
  VStack,
  HStack,
  Box,
  SkeletonText,
  SkeletonCircle,
  Divider,
} from "@chakra-ui/react";

const CallLoadingSkeleton = () => {
  // Create an array for placeholder items
  const placeholders = Array(10).fill(0);

  return (
    <VStack align="start" spacing={0} w="100%" p={0}>
      {placeholders.map((_, index) => (
        <HStack w="full" p={2} spacing={4} key={index} borderRadius="lg">
          <SkeletonCircle size="10" />

          <Box flex="1">
            {/* Top row: name and timestamp */}
            <HStack justifyContent="space-between">
              <SkeletonText noOfLines={1} width="150px" />
              <SkeletonText noOfLines={1} width="80px" ml="50px" />
            </HStack>

            {/* Second row: call type/direction/duration and info icon */}
            <HStack justifyContent="space-between" w="full" mb={1}>
              <HStack spacing={2}>
                {/* Mimic audio/video/direction icons */}
                <SkeletonCircle size="4" />
                <SkeletonCircle size="4" />
                <SkeletonText noOfLines={1} width="50px" />
              </HStack>
              {/* Info icon skeleton */}
              <SkeletonCircle size="5" />
            </HStack>

            {index < placeholders.length - 1 && <Divider />}
          </Box>
        </HStack>
      ))}
    </VStack>
  );
};

export default CallLoadingSkeleton;
